import {
  VStack,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  AccordionPanel,
  Box,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { TEXT_COLOR_LIGHT, TEXT_COLOR_DARK } from "./utils";

interface Props {
  children: JSX.Element;
}

export function SearchAllFields({ children }: Props) {
  const textColor = useColorModeValue(TEXT_COLOR_LIGHT, TEXT_COLOR_DARK);

  return (
    <VStack alignItems="flex-start">
      <Text fontSize="13px" fontWeight="semibold" color={textColor}>
        Search all fields
      </Text>
      {children}
      <Accordion px="1.5" allowToggle>
        <AccordionItem border="none">
          <AccordionButton w="auto" px="2" pb="0" _hover={{ bg: "initial" }}>
            <Box
              as="span"
              flex="1"
              textAlign="left"
              fontSize="sm"
              fontWeight="semibold"
            >
              How it works
            </Box>
            <AccordionIcon />
          </AccordionButton>
          <AccordionPanel px="2" fontSize="11.5px">
            Use this to search for keywords throughout entire LinkedIn profile
            data instead of one specific field. This is adapted to a broad
            search for specific keywords. Combine that with Profile and Company
            filters to find your ideal leads or target audience.
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </VStack>
  );
}
